//-----------CORE------------//
import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import mapboxgl from "!mapbox-gl";
//------------MUI------------//
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
//-----------EXTERNAL COMPS---------//
import { useEditDeviceMutation } from "services/devices";
import { useGetEventsQuery, useCreateEventMutation } from "services/events";
import eventsApi from "services/events";
import devicesApi from "services/devices";
import { addLocationSearch } from "utils/mapLocationSearch";

mapboxgl.accessToken =
  "pk.eyJ1IjoiaW52aXhpYmxlZGV2IiwiYSI6ImNraXNvbGYwYjBtYWQyd3Njd2lkeTRsNnMifQ.M-WA639AR9Rcf52HgCa8UA";

const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: "fixed",
    bottom: "30px",
    right: "30px",
    zIndex: 20,
  },
}));
// let c8y_Position = {
//   lng:-0.118092,
//   lat:51.509865
// }
let marker;

export default function AddDevices(props) {
  let token = window.localStorage.getItem("token");
  const dispatch = useDispatch();
  let deviceEdit = props.deviceEdit;
  const metaData = useSelector((state) => state.metaData?.services);
  const idMap = useSelector((state) => state.metaData?.idMap);
  const deviceForm = useFormik({
    initialValues: {
      name: deviceEdit ? deviceEdit.name : "",
      firmware: deviceEdit ? deviceEdit.firmware : "",
      serialNumber: deviceEdit ? deviceEdit.serialNumber : "",
      imei: deviceEdit ? deviceEdit.imei : "",
      service: deviceEdit ? deviceEdit.dashboard : "",
      lat: deviceEdit ? deviceEdit.lat : "",
      lng: deviceEdit ? deviceEdit.lng : "",
      platformDeviceType: deviceEdit ? deviceEdit.platformDeviceType : "",
      imsi: deviceEdit ? deviceEdit.imsi : "",
      iccid: deviceEdit ? deviceEdit.iccid : "",
      msisdn: deviceEdit ? deviceEdit.msisdn : "",
      lat: deviceEdit ? deviceEdit?.location?.latitude : "",
      lng: deviceEdit ? deviceEdit?.location?.longitude : "",

    },
    validationSchema: Yup.object({
      name: Yup.string().required("Required field"),
      firmware: Yup.string(),
      serialNumber: Yup.string(),
      imei: Yup.string(),
      imsi: Yup.string(),
      iccid: Yup.string(),
      msisdn: Yup.string(), 
      lat: Yup.string(),
      lng: Yup.string(),
      service: Yup.string().required("Required field"),
    }),
    onSubmit: async (values) => {
      onSubmitAdd(values);
    },
  });
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [c8y_Position, setC8y_Position] = React.useState({
    lng: -0.118092,
    lat: 51.509865,
  });
  const [selectedSolution, setSelectedSolution] = useState(
    deviceEdit
      ? metaData.find((s) => s.id == idMap[deviceEdit.dashboard])
      : null
  );
  const [validLat, setValidLat] = React.useState(true);
  const [validLng, setValidLng] = React.useState(true);
  const [updateDevice, updateResult] = useEditDeviceMutation();
  const [createEvent, createEventResult] = useCreateEventMutation();

  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    return () => {
      dispatch(eventsApi.util.resetApiState());
    };
  }, []);

  // D30 (1): the pin's position is the dialog's location, exactly as a map click sets it
  // (c8y_Position { lng, lat } and the two fields); Submit saves c8y_Position.
  const setPinPosition = (lng, lat) => {
    setC8y_Position({ lng, lat });
    setValidLat(true);
    setValidLng(true);
    deviceForm.setFieldValue("lat", lat);
    deviceForm.setFieldValue("lng", lng);
  };

  useEffect(() => {
    if (mapContainer.current && c8y_Position.lng) {
      if (map.current) return; // initialize map only once
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/mapbox/streets-v11",
        center: [c8y_Position.lng, c8y_Position.lat],
        zoom: 10,
      });
      map.current.addControl(new mapboxgl.NavigationControl());
      // D30 (1): location search. It only moves the map and drops a draggable pin at the
      // picked place (Mapbox's search results may not be stored); the location saved is the
      // pin the user confirms with Submit, as with a map click.
      addLocationSearch(map.current, mapboxgl, {
        defaultLocation: selectedSolution?.defaultLocation,
        onPick: ({ lng, lat }) => {
          if (marker) {
            marker.remove();
          }
          setPinPosition(lng, lat);
          marker = new mapboxgl.Marker({ draggable: true })
            .setLngLat([lng, lat])
            .addTo(map.current);
          marker.on("dragend", (e) => {
            const p = e.target.getLngLat();
            setPinPosition(p.lng, p.lat);
          });
        },
      });
      map.current.on("click", (e) => {
        if (marker) {
          marker.remove();
        }
        map.current.flyTo({
          center: [e.lngLat.lng, e.lngLat.lat],
        });
        setC8y_Position({
          lng: e.lngLat.lng,
          lat: e.lngLat.lat,
        });
        setValidLat(true);
        setValidLng(true);
        deviceForm.setFieldValue("lat", e.lngLat.lat);
        deviceForm.setFieldValue("lng", e.lngLat.lng);
        marker = new mapboxgl.Marker()
          .setLngLat([e.lngLat.lng, e.lngLat.lat])
          .addTo(map.current);
      });
      return () => {
        // connector.emit("DC");
        map.current.remove();
      };
    }
  }, [mapContainer.current]);

  useEffect(() => {
    if (!props.deviceEdit) {
      deviceForm.setFieldValue("name", "");
      deviceForm.setFieldValue("firmware", "");
      deviceForm.setFieldValue("serialNumber", "");
      deviceForm.setFieldValue("imei", "");
      deviceForm.setFieldValue("service", "");
      deviceForm.setFieldValue("lng", "");
      deviceForm.setFieldValue("lat", "");
      deviceForm.setFieldValue("iccid", "")
      deviceForm.setFieldValue("imsi", "")
      deviceForm.setFieldValue("msisdn", "")
    }
  }, [props.deviceEdit]);
  const events = useGetEventsQuery(
    {
      token,
      params: `?pageSize=1&currentPage=1&type=c8y_LocationUpdate&source=${props.deviceEdit.html}`,
    },
    { skip: !props.deviceEdit }
  );
  function showSnackbar(title, message, variant, timeOut) {
    return enqueueSnackbar(
      { title, message: message ? message : "Something went wrong", variant },
      { timeOut }
    );
  }

  useEffect(() => {
    if (!events.isFetching && events.isSuccess) {
      if (events.data?.payload?.data?.length) {
        let tempLoc = events.data.payload.data[0].c8y_Position;
        if (tempLoc) {
          setC8y_Position(tempLoc);
          map.current.flyTo({
            center: [tempLoc.lng, tempLoc.lat],
          });
          marker = new mapboxgl.Marker()
            .setLngLat([tempLoc.lng, tempLoc.lat])
            .addTo(map.current);
        } else {
          map.current.flyTo({
            center: [c8y_Position.lng, c8y_Position.lat],
          });
          marker = new mapboxgl.Marker()
            .setLngLat([c8y_Position.lng, c8y_Position.lat])
            .addTo(map.current);
        }
      }
    }
    if (!events.isFetching && events.isError) {
      showSnackbar("Location", "Could not fetch location", "error", 1000);
    }
  }, [events.isFetching]);

  var onSubmitAdd = async () => {
    let body = JSON.parse(JSON.stringify(deviceForm.values));
    if (
      selectedSolution &&
      selectedSolution.assets &&
      selectedSolution.assets.length > 1
    ) {
      if (!body.platformDeviceType || body.platformDeviceType === "") {
        showSnackbar("Device", "Asset type is required", "error", 1000);
        return;
      }
    } else {
      delete body.platformDeviceType;
    }
    body.serviceId = idMap[body.service];
    body.firmwareVersion = body.firmware;
    body.location = metaData.find(
      (s) => s.id == idMap[body.service]
    )?.defaultLocation;
    delete body.firmware;
    delete body.service;
    // D29 (b): this dialog only edits an existing device - adding by hand is removed.
    if (props.deviceEdit) {
    let bodyToUpdate = {}
      bodyToUpdate.serviceId = body.serviceId
      if(body.firmwareVersion !== props.deviceEdit?.firmware){
        bodyToUpdate.firmwareVersion = body.firmwareVersion
      }
      if(body.serialNumber !== props.deviceEdit?.serialNumber){
        bodyToUpdate.serialNumber = body.serialNumber
      }
      if(body.imei !== props.deviceEdit?.imei){
        bodyToUpdate.imei = body.imei
      }
      if(body.imsi !== props.deviceEdit?.imsi){
        bodyToUpdate.imsi = body.imsi
      }
      if(body.msisdn !== props.deviceEdit?.msisdn){
        bodyToUpdate.msisdn = body.msisdn
      }
      if(body.iccid !== props.deviceEdit?.iccid){
        bodyToUpdate.iccid = body.iccid
      }
      if(body.name !== props.deviceEdit?.name){
        bodyToUpdate.name = body.name
      }
      bodyToUpdate.platformDeviceType = body.platformDeviceType
      let updated = await updateDevice({
        token,
        body: bodyToUpdate,
        id: props.deviceEdit.html,
      });
      let type = "error";
      if (updated.data?.success) {
        if (updated.data.payload?.internalId) {
          let eventsBody = {
            deviceId: updated.data.payload.internalId,
            c8y_Position,
            text: "Asset location specified",
            type: "c8y_LocationUpdate",
            time: new Date(),
          };
          let createdEvent = await createEvent({ token, body: eventsBody });
        }
        type = "success";
        deviceForm.resetForm();
        props.handlepopupToggle2();
        props.handleUpdateDevice(body, props.deviceEdit.html);
      }
      showSnackbar("Device", updated.data?.message, type, 1000);
    }
  };

  return (
    <div>
      <Dialog
        open={props.openPopup2}
        onClose={props.handlepopupToggle2}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
        maxHeight="lg"
      >
        <form onSubmit={deviceForm.handleSubmit}>
          <DialogTitle id="form-dialog-title">
            {props.deviceEdit
              ? `Update Device (${String(props.deviceEdit.name || "").trim()})`
              : "Update Device"}
          </DialogTitle>
          <DialogContent style={{ display: "flex", gap: 20 }}>
            <div style={{ width: "50%" }}>
              <p style={{ fontSize: 14, fontWeight: "bold", color: "#999" }}>
                Device Details
              </p>
              <TextField
                id="name"
                error={
                  deviceForm.touched.name && deviceForm.errors.name
                    ? true
                    : false
                }
                margin="dense"
                style={{
                  marginBottom: "5px",
                }}
                value={deviceForm.values.name}
                onChange={deviceForm.handleChange}
                onBlur={deviceForm.handleBlur}
                fullWidth
                label="Name"
                helperText={
                  deviceForm.touched.name ? deviceForm.errors.name : ""
                }
              />
              <TextField
                id="firmware"
                error={
                  deviceForm.touched.firmware && deviceForm.errors.firmware
                    ? true
                    : false
                }
                margin="dense"
                style={{
                  marginBottom: "5px",
                }}
                value={deviceForm.values.firmware}
                onChange={deviceForm.handleChange}
                onBlur={deviceForm.handleBlur}
                fullWidth
                label="Firmware"
                helperText={
                  deviceForm.touched.firmware ? deviceForm.errors.firmware : ""
                }
              />
              <TextField
                id="serialNumber"
                error={
                  deviceForm.touched.serialNumber &&
                  deviceForm.errors.serialNumber
                    ? true
                    : false
                }
                margin="dense"
                style={{
                  marginBottom: "5px",
                }}
                value={deviceForm.values.serialNumber}
                onChange={deviceForm.handleChange}
                onBlur={deviceForm.handleBlur}
                fullWidth
                label="Serial Number"
                helperText={
                  deviceForm.touched.serialNumber
                    ? deviceForm.errors.serialNumber
                    : ""
                }
              />
              <TextField
                id="imei"
                error={
                  deviceForm.touched.imei && deviceForm.errors.imei
                    ? true
                    : false
                }
                margin="dense"
                style={{
                  marginBottom: "5px",
                }}
                value={deviceForm.values.imei}
                onChange={deviceForm.handleChange}
                onBlur={deviceForm.handleBlur}
                fullWidth
                label="IMEI"
                helperText={
                  deviceForm.touched.imei ? deviceForm.errors.imei : ""
                }
              />
              <TextField
                id="imsi"
                error={
                  deviceForm.touched.imsi && deviceForm.errors.imsi
                    ? true
                    : false
                }
                margin="dense"
                style={{
                  marginBottom: "5px",
                }}
                value={deviceForm.values.imsi}
                onChange={deviceForm.handleChange}
                onBlur={deviceForm.handleBlur}
                fullWidth
                label="IMSI"
                helperText={
                  deviceForm.touched.imsi ? deviceForm.errors.imsi : ""
                }
              />
              <TextField
                id="iccid"
                error={
                  deviceForm.touched.iccid && deviceForm.errors.iccid
                    ? true
                    : false
                }
                margin="dense"
                style={{
                  marginBottom: "5px",
                }}
                value={deviceForm.values.iccid}
                onChange={deviceForm.handleChange}
                onBlur={deviceForm.handleBlur}
                fullWidth
                label="ICCID"
                helperText={
                  deviceForm.touched.iccid ? deviceForm.errors.iccid : ""
                }
              />
              <TextField
                id="msisdn"
                error={
                  deviceForm.touched.msisdn && deviceForm.errors.msisdn
                    ? true
                    : false
                }
                margin="dense"
                style={{
                  marginBottom: "5px",
                }}
                value={deviceForm.values.msisdn}
                onChange={deviceForm.handleChange}
                onBlur={deviceForm.handleBlur}
                fullWidth
                label="MSISDN"
                helperText={
                  deviceForm.touched.msisdn ? deviceForm.errors.msisdn : ""
                }
              />
              <div style={{ display: "flex", gap: "10px" }}>
                <div style={{ width: "50%" }}>
                  <TextField
                    id="lat"
                    error={
                      deviceForm.touched.lat && deviceForm.errors.lat
                        ? true
                        : false
                    }
                    margin="dense"
                    style={{
                      marginBottom: "5px",
                    }}
                    value={deviceForm.values.lat || ""}
                    onChange={(e) => {
                      if (e.target.value >= -90 && e.target.value <= 90) {
                        setValidLat(true);
                        setC8y_Position({
                          ...c8y_Position,
                          lat: e.target.value,
                        });
                        if (validLat && validLng) {
                          if (marker) {
                            marker.remove();
                          }
                          map.current.flyTo({
                            center: [c8y_Position.lng, e.target.value],
                          });
                          marker = new mapboxgl.Marker()
                            .setLngLat([c8y_Position.lng, e.target.value])
                            .addTo(map.current);
                        }
                      } else {
                        // console.log("invalid");
                        setValidLat(false);
                      }
                      deviceForm.handleChange(e);
                    }}
                    onBlur={deviceForm.handleBlur}
                    fullWidth
                    label="Latitude"
                    helperText={
                      deviceForm.touched.lat ? deviceForm.errors.lat : null
                    }
                  />
                  {!validLat ? (
                    <div style={{ fontSize: "10px", color: "red" }}>
                      Invalid Latitude
                    </div>
                  ) : null}
                </div>
                <div style={{ width: "50%" }}>
                  <TextField
                    id="lng"
                    error={
                      deviceForm.touched.lng && deviceForm.errors.lng
                        ? true
                        : false
                    }
                    margin="dense"
                    style={{
                      marginBottom: "5px",
                    }}
                    value={deviceForm.values.lng || ""}
                    onChange={(e) => {
                      if (e.target.value >= -180 && e.target.value <= 180) {
                        setValidLng(true);
                        setC8y_Position({
                          ...c8y_Position,
                          lng: e.target.value,
                        });
                        if (validLat && validLng) {
                          if (marker) {
                            marker.remove();
                          }
                          map.current.flyTo({
                            center: [e.target.value, c8y_Position.lat],
                          });
                          marker = new mapboxgl.Marker()
                            .setLngLat([e.target.value, c8y_Position.lat])
                            .addTo(map.current);
                        }
                      } else {
                        setValidLng(false);
                      }
                      deviceForm.handleChange(e);
                    }}
                    onBlur={deviceForm.handleBlur}
                    fullWidth
                    label="Longitude"
                    helperText={
                      deviceForm.touched.lng ? deviceForm.errors.lng : null
                    }
                  />
                  {!validLng ? (
                    <div style={{ fontSize: "10px", color: "red" }}>
                      Invalid Longitude
                    </div>
                  ) : null}
                </div>
              </div>
              <FormControl
                fullWidth
                className={classes.formControl}
                margin="dense"
              >
                <InputLabel>Solution</InputLabel>
                <Select
                  value={deviceForm.values.service}
                  error={
                    deviceForm.touched.service && deviceForm.errors.service
                      ? true
                      : false
                  }
                  name="service"
                  fullWidth
                  onChange={(e) => {
                    let solution = metaData.find(
                      (s) => s.id == idMap[e.target.value]
                    );
                    deviceForm.setFieldValue("platformDeviceType", "");
                    setSelectedSolution(solution);
                    let defaultLocation = solution?.defaultLocation;
                    if (defaultLocation && defaultLocation.length) {
                      // console.log({ defaultLocation });
                      setC8y_Position({
                        lng: defaultLocation[0],
                        lat: defaultLocation[1],
                      });
                      // console.log({ defaultLocation });
                      deviceForm.setFieldValue("lat", defaultLocation[1]);
                      deviceForm.setFieldValue("lng", defaultLocation[0]);
                      if(marker){
                        marker.remove()
                      }
                      marker = new mapboxgl.Marker()
                      .setLngLat([defaultLocation[0], defaultLocation[1]])
                      .addTo(map.current);
                      map.current.flyTo({
                        center: [defaultLocation[0], defaultLocation[1]],
                      });
                    }
                    deviceForm.handleChange(e);
                  }}
                  label="Solution"
                  helperText={
                    deviceForm.touched.service ? deviceForm.errors.service : ""
                  }
                >
                  {metaData.map((elm) => {
                    return <MenuItem value={elm.name}>{elm.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
              {selectedSolution &&
              selectedSolution.assets &&
              selectedSolution.assets.length > 1 ? (
                <FormControl
                  fullWidth
                  className={classes.formControl}
                  margin="dense"
                >
                  <InputLabel>Asset type</InputLabel>
                  <Select
                    value={deviceForm.values.platformDeviceType}
                    error={
                      deviceForm.touched.platformDeviceType &&
                      deviceForm.errors.platformDeviceType
                        ? true
                        : false
                    }
                    name="platformDeviceType"
                    fullWidth
                    onChange={(e) => {
                      // console.log("e.target.value", e.target.value);
                      deviceForm.setFieldValue(
                        "platformDeviceType",
                        e.target.value
                      );
                    }}
                    label="platformDeviceType"
                    helperText={
                      deviceForm.touched.platformDeviceType
                        ? deviceForm.errors.platformDeviceType
                        : ""
                    }
                  >
                    {selectedSolution.assets.map((elm) => {
                      return (
                        <MenuItem value={elm.id || elm._id}>
                          {elm.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              ) : null}
            </div>
            <div style={{ width: "50%" }}>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  color: "#999",
                  marginBottom: 6,
                }}
              >
                Device Location
              </p>
              {props.deviceEdit ? (
                events.isFetching ? (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress size={40} />
                  </div>
                ) : null
              ) : null}
              {/* D30 (1): keys typed in the map's search box stay there (its own handlers run
                  first): Enter never submits this form, which would save the pin's current
                  location, and Escape never closes the dialog with unsaved edits. */}
              <div
                ref={mapContainer}
                onKeyDown={(e) => {
                  if (e.target.tagName !== "INPUT") return;
                  if (e.key === "Enter") e.preventDefault();
                  if (e.key === "Escape") e.stopPropagation();
                }}
                style={{
                  height: "calc(100% - 30px)",
                  borderRadius: "10px",
                  visibility: props.deviceEdit
                    ? events.isFetching
                      ? "hidden"
                      : "inherit"
                    : "inherit",
                }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={props.handlepopupToggle2}>Cancel</Button>
            {updateResult.isLoading ||
            createEventResult.isLoading ? (
              <CircularProgress style={{ margin: "0px 16px" }} size={20} />
            ) : (
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={events.isFetching}
              >
                <span>Submit</span>
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
